import { Event } from '@sentry/types/types/event';
import { EventHint } from '@sentry/vue';
import { AxiosError } from 'axios';
import { STAT_ACCESS_URL } from '@/shared/services';

export function beforeSend(event: Event, hint: EventHint): null|Event {
  if (hint?.originalException) {
    // skip Axios requests logging until we have a better idea on what to collect
    const isAxiosRequest = hint.originalException instanceof AxiosError;

    if (isAxiosRequest) {
      return null;
    }
  }

  return event;
}

export function beforeBreadcrumb(breadcrumb, hint) {
  // remove statistics from the breadcrumbs
  if (breadcrumb.category === 'xhr' && hint?.xhr) {
    const url = hint.xhr.responseURL;
    const filteredEndpoints = [STAT_ACCESS_URL];

    if (filteredEndpoints.some(endpoint => url.includes(endpoint))) {
      return null;
    }
  }

  return breadcrumb;
}
